//returns current day today MM DD YYYY
const dateToday = () => {
    let newDate = new Date(Date.now());
    let monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return `${monthList[newDate.getMonth()]} ${newDate.getDate()} ${newDate.getUTCFullYear()}`;
}

//local storage actions
class LocalMethods {
    getLocalData = () => {
        const notes = localStorage.getItem('diurnal-notes') || '[]';
        return JSON.parse(notes);
    }
    storeLocalData = (content) => {
        localStorage.setItem('diurnal-notes', JSON.stringify(content));
    }
    removeData = () => {
        localStorage.removeItem('diurnal-notes');
    }
}
const Local = new LocalMethods();

export {dateToday, Local}